// EmptyListingsState.jsx
// Component for displaying no listings state

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { styles } from './styles';

// Modern SVG Icons
const BoxIcon = () => (
  <svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <line x1="16.5" y1="9.4" x2="7.5" y2="4.21" />
    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
    <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
    <line x1="12" y1="22.08" x2="12" y2="12" />
  </svg>
);

const PlusCircleIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="8" x2="12" y2="16" />
    <line x1="8" y1="12" x2="16" y2="12" />
  </svg>
);

const EmptyListingsState = () => {
  const navigate = useNavigate();

  return (
    <div style={styles.emptyStateContainer}>
      <div style={styles.emptyStateIcon}>
        <BoxIcon />
      </div>
      <h2 style={styles.emptyStateTitle}>No Listings Yet</h2>
      <p style={styles.emptyStateText}>
        You haven't created any listings. Start selling your items to the ISU community!
      </p>
      <button
        style={styles.emptyStateButton}
        onClick={() => navigate('/add-listing')}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = '#a00f20';
          e.currentTarget.style.transform = 'translateY(-2px)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = '#CE1126';
          e.currentTarget.style.transform = 'translateY(0)';
        }}
      >
        <PlusCircleIcon />
        <span>Create Your First Listing</span>
      </button>
    </div>
  );
};

export default EmptyListingsState;